import * as firebase from 'firebase/app'
import 'firebase/database';
import 'firebase/auth';
//Depolyment test
// firebase.initializeApp({
//     apiKey: "AIzaSyAGrqaU9nx_CZTuoj3FB7GrIzi6oQRENRM",
//     authDomain: "deployment-test-bb422.firebaseapp.com",
//     databaseURL: "https://deployment-test-bb422.firebaseio.com",
//     projectId: "deployment-test-bb422",
//     storageBucket: "deployment-test-bb422.appspot.com",
//     messagingSenderId: "710168254388"
// })
// Production
firebase.initializeApp({
  apiKey: "AIzaSyCiDqtLznBeqRLBjpFokutmoxPdbLTLxI4",
  authDomain: "student-data-firebase.firebaseapp.com",
  databaseURL: "https://student-data-firebase.firebaseio.com",
  projectId: "student-data-firebase",
  storageBucket: "student-data-firebase.appspot.com",
  messagingSenderId: "907059409933"
})

export const db = firebase.database();
export const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({
  hd: 'oakwoodfriends.org'
});
